import type { FeatureFlag } from './feature-flag-types'

export const FeatureFlagName = {
  // ==========================================
  // Flags Permanentes
  // Precisam ser revisadas periodicamente para avaliar se ainda fazem sentido ou se devem ser removidas
  // ==========================================
  ENABLE_CONTACT_VALIDATION: {
    name: 'skillcustomer-contact-validation',
    defaultValue: false
  },
  ENABLE_ONBOARDING_CONTACT_VALIDATION: {
    name: 'skillcustomer-onboarding-contact-validation',
    defaultValue: false
  },
  INVISIBLE_RECAPTCHA: {
    name: 'skillcustomer-invisible-recaptcha',
    defaultValue: false
  },
  COMPANIES_WITH_CUSTOM_HELP_CENTER: {
    name: 'skillcustomer-companies-custom-help-center',
    defaultValue: []
  },
  PARTNER_CANCEL_NOT_ALLOWED: {
    name: 'skillcustomer-partner-cancel-not-allowed',
    defaultValue: []
  },
  ENROLLMENT_REQUIRES_BIOMETRY: {
    name: 'skillweb-auth-require-biometry',
    defaultValue: true
  },
  COMPANIES_WITH_PROFILE_ASSESSMENT: {
    name: 'skillcustomer-companies-with-profile-assessment',
    defaultValue: false
  },
  USER_SPACE_ENABLED: {
    name: 'skillcustomer-user-space-enabled',
    defaultValue: false
  },
  ENGAGE_DATA: {
    name: 'skillcustomer-company-dashboards-engage',
    defaultValue: {}
  },

  // ==========================================
  // Novas flags devem ser adicionadas abaixo, seguindo a mesma estrutura dos objetos anteriores
  // ==========================================
  ENABLE_NEW_COLLABORATORS_FLOW: {
    name: 'skill-customer-enable-new-collaborators-flow',
    defaultValue: false
  },
  ENABLE_NEW_AUTHORIZATIONS_FLOW: {
    name: 'skill-customer-enable-new-authorizations-flow',
    defaultValue: false
  },
  ENABLE_CAREER_MENTOR: {
    name: 'skill-customer-enable-career-mentor',
    defaultValue: false
  },
  ENABLED_RECAPTCHA_V3: {
    name: 'skill-customer-web-enabled-recaptcha-v-3',
    defaultValue: false
  },
  ENABLED_NEW_COMPANY_MANAGER: {
    name: 'skill-customer-web-company-manager',
    defaultValue: false
  }
} as const

/**
 * Type helper for TypeScript
 */
export type FeatureFlagNameType = typeof FeatureFlagName

/**
 * Helper to get all flags as array
 * Used internally for initialization and caching
 */
export const getAllFlags = (): FeatureFlag[] => Object.values(FeatureFlagName)
